import type { ComponentProps } from 'react';
import { OwcSwitch } from '@one/react';

export type PocSwitchProps = ComponentProps<typeof OwcSwitch>;

export const PocSwitch: React.FC<PocSwitchProps> = (props) => <OwcSwitch {...props} />;
